<div [hidden]="!PartialViewReady" class="padding-20">
    <h2 class="mat-title">
        College Contact Information
    </h2>
    <div>
        <div>Listed below are the contact information for each college to receive college advisor email notifications.</div>
        <div class="buttongroup addCollegeContact" fxLayout="row" fxLayoutAlign="start start" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start center" *ngIf="ShowingContactEntryPanel !== true">
            <button mat-raised-button color="primary" (click)="ShowContactInfoEditorPanel()">Add College Contact</button>
        </div>
    </div>
    <div *ngIf="ShowingContactEntryPanel" class="mat-elevation-z12 entrypanel padding-20" style="margin-bottom:20px">
        <h2 class="mat-headline">{{IsEditContact ? 'Edit' : 'New'}} Contact Panel</h2>
        <p>This panel is used to create/edit a college contact.</p>
        <form [formGroup]="CollegeContactForm" novalidate fxLayout="column">
            <div fxLayout="row" fxLayout.lt-md="column">
                <mat-form-field style="margin-right:15px">
                    <mat-select formControlName="CollegeID" placeholder="Select College...">
                        <mat-option *ngFor="let col of Colleges" [value]="col.CollegeID">{{ col.CollegeName }}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="CollegeContactForm.controls['CollegeID'].hasError('required')">College required</mat-error>
                </mat-form-field>
                <mat-form-field style="margin-right:15px">
                    <input matInput formControlName="Email" placeholder="Email" />
                    <mat-error *ngIf="CollegeContactForm.controls['Email'].hasError('required')">Email required</mat-error>
                    <mat-error *ngIf="CollegeContactForm.controls['Email'].hasError('pattern')">Email is not a valid email address</mat-error>
                </mat-form-field>
            </div>
        </form>
        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px">        
            <button *ngIf="CollegeContactForm.value.CollegeContactID == null" mat-raised-button color="primary" (click)="AddCollegeContact()" [disabled]="CollegeContactForm.invalid">Add</button>
            <button *ngIf="CollegeContactForm.value.CollegeContactID != null" mat-raised-button color="primary" (click)="UpdateCollegeContactHandler()" [disabled]="CollegeContactForm.invalid">Update</button>
            <button mat-raised-button color="warn" (click)="ResetCollegeContact()">Cancel</button>
        </div>
    </div>

    <!-- College Contacts Table -->
    <mat-table class="bordered" #table [dataSource]="CollegeContactData" matSort matSortActive="CollegeName" matSortDirection="desc">
        <ng-container matColumnDef="CollegeName">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">College</mat-header-cell>
            <mat-cell *matCellDef="let col" class="centered">{{ col.CollegeName }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Email">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Email</mat-header-cell>
            <mat-cell *matCellDef="let col" class="centered">{{ col.Email }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Actions">
            <mat-header-cell *matHeaderCellDef class="centered">Action(s)</mat-header-cell>
            <mat-cell *matCellDef="let col" class="centered">
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px" fxLayoutWrap>
                    <button mat-raised-button color="primary" (click)="ShowContactInfoEditorPanel(col)" class="buttonpad">Edit Contact</button>
                    <button mat-raised-button color="warn" (click)="RemoveCollegeContact(col)" class="buttonpad">Remove Contact</button>
                </div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="SmallDisplay">
            <mat-header-cell *matHeaderCellDef class="centered">College Contact(s)</mat-header-cell>
            <mat-cell *matCellDef="let cc">
                <div fxLayout="column" fxLayoutAlign="start stretch">
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div>College</div>
                        <div>{{cc.CollegeName}}</div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <div>Email</div>
                        <div>{{cc.Email}}</div>
                    </div>
                    <div class="smalldisplaybuttongroup" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
                        <button mat-raised-button color="primary" (click)="ShowContactInfoEditorPanel(cc)">Edit Contact</button>
                        <button mat-raised-button color="warn" (click)="RemoveCollegeContact(cc)">Remove Contact</button>
                    </div>
                </div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="NoData">
            <mat-header-cell *matHeaderCellDef>&nbsp;</mat-header-cell>
            <mat-cell *matCellDef="let term"><em>No college contacts have been set.</em></mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="VisibleHeaders"></mat-header-row>
        <mat-row *matRowDef="let row;columns: VisibleColumns;let $even = even" [class.primarybackground50]="$even"></mat-row>
    </mat-table>
    <mat-paginator #paginator [length]="CollegeContactData.data.length" [pageIndex]="0" [pageSize]="(SmallDisplay ? 5 : 10)" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
</div>


// WEBPACK FOOTER //
// ./src/app/admin-settings/components/college-contact/college-contact.component.html